// extracted by mini-css-extract-plugin
export default {"patrocinadores":"Patrocinadores_patrocinadores__870B-"};